/**
 * Side-effect module: registers the bookings record side-panels with the shell's record-panel
 * registry (DR-11). Registration is LAZY (registerLazyRecordPanel): the
 * mapping is installed synchronously at boot so deep links resolve, but the
 * panel component (and its dependency graph) stays out of the entry chunk
 * and loads on first open. Idempotent.
 */

import { registerLazyRecordPanel } from '../../shell/record-panel-registry'

registerLazyRecordPanel('booking', () =>
  import('./booking-side-panel').then((m) => ({ default: m.BookingSidePanel })),
)
registerLazyRecordPanel('event_type', () =>
  import('./event-type-side-panel').then((m) => ({ default: m.EventTypeSidePanel })),
)
registerLazyRecordPanel('availability_schedule', () =>
  import('./availability-schedule-side-panel').then((m) => ({
    default: m.AvailabilityScheduleSidePanel,
  })),
)
registerLazyRecordPanel('workflow', () =>
  import('./workflow-side-panel').then((m) => ({ default: m.WorkflowSidePanel })),
)
